export default __webpack_public_path__ + "static/spiritual-india-people-2-8f0049ef342d67b5dde8fb3f3b6313e5.jpg";